const PACKAGES = [
  'one_month_credit',
  'three_months_credit',
  'six_months_credit',
  'one_year_credit',
  'two_years_credit',
  'lifetime_membership',
  'one_month_credit_premium',
  'three_months_credit_premium',
  'one_year_credit_premium',
  'lifetime_membership_premium',
  'one_month_credit_nova_premium',
  'three_months_credit_bundle_elsa_pre_pro',
  'one_year_credit_bundle_elsa_pre_pro',
  'lifetime_membership_bundle_elsa_pre_pro',
];

const isMembershipExist = (packages, membership) => {
  let result = false;
  if (Array.isArray(membership) && membership.length > 0) {
    for(let i = 0; i < membership.length; i++) {
      if (packages.includes(membership[i])) {
        result = true;
      } else {
        result = false;
        break;
      }
    }
  } else {
    result = false;
  }
  return result;
};

const buildMembership = (arrayPackages) => {
  var membershipString = '';
  if (arrayPackages.length < 1) return;
  if (arrayPackages.length === 1) {
    membershipString = arrayPackages[0];
  } else {
    arrayPackages.map((item, index) => {
      if (index === arrayPackages.length - 1) {
        membershipString += `1 x ${item}`;
      } else {
        membershipString += `1 x ${item} and `;
      }
    });
  }
  return membershipString;
};

const buildMembershipObj = (arrayPackages) => {
  var membershipObj = {};
  if (arrayPackages.length < 1) return;
  arrayPackages.map(item => {
    membershipObj[item] = 1;
  });
  return membershipObj;
};

const formHandler = () => {
  $.validator.addMethod('email', function(value, element) {
    if (element.value !== '') {
      return this.optional(element) || /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,24}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i.test(value);
    } else {
      return true;
    }
  });

  $('input[name="search"]').val(location.search);

  if ($('.js-form-register').length) {
    var rules = {
      fullname: {
        required: true,
      },
      email: {
        required: true,
        email: true,
      },
      membership_name: {
        required: true,
      },
    };

    var messages = {
      fullname: {
        required: 'The full name field is required.',
      },
      email: {
        required: 'The email field is required.',
        email: 'The email is not valid.',
      },
      membership_name: {
        required: 'Please select at least 1 package.',
      }
    };

    $('.js-form-register').each(function() {
      $(this).validate({
        rules: rules,
        messages: messages,
        errorElement: 'div',
        errorClass: 'text-danger form-error',
        errorPlacement: function (error, element) {
          element.closest('.js-form-error').append(error);
        }
      });
    });
  }

  $('.js-form-register').each(function() {
    var form = $(this);
    form.on('submit', function (event) {
      event.preventDefault();
      var checkedBoxes = [];
      var hasError = false;

      form.find('input[name="membership_name"]:checked').map(function() {
        checkedBoxes.push($(this).val());
      });

      if (isMembershipExist(PACKAGES, checkedBoxes)) {
        var membershipString = buildMembership(checkedBoxes);
        $('input[name="membership"]').val(membershipString);
      } else {
        hasError = true;
        if($('input[name="membership_name"]:checked').length > 0) {
          alert('Package invalid!');
        }
      }
      if (form.valid() && !hasError) {
        const packageName = {
          three_months_credit: {
            amount: '468',
            label: 'THREE MONTHS CREDIT'
          },
          six_months_credit: {
            amount: '888',
            label: 'SIX MONTHS CREDIT'
          },
          one_year_credit: {
            amount: '1228',
            label: 'ONE YEAR CREDIT'
          },
          three_months_credit_premium: {
            amount: '1028',
            label: 'THREE MONTHS CREDIT PREMIUM'
          },
          one_month_credit_premium: {
            amount: '428',
            label: 'ONE MONTH CREDIT PREMIUM'
          },
          one_year_credit_premium: {
            amount: '2928',
            label: 'ONE YEAR CREDIT PREMIUM'
          },
          lifetime_membership: {
            amount: '3875',
            label: 'LIFETIME MEMBERSHIP'
          },
          oxford_starter: {
            amount: '179',
            label: 'OXFORD STARTER'
          },
          oxford_elementary: {
            amount: '179',
            label: 'OXFORD ELEMENTARY'
          },
          oxford_pre_intermediate: {
            amount: '179',
            label: 'OXFORD PRE INTERMEDIATE'
          },
          oxford_intermediate: {
            amount: '179',
            label: 'OXFORD INTERMEDIATE'
          },
          oxford_upper_intermediate: {
            amount: '179',
            label: 'OXFORD UPPER INTERMEDIATE'
          },
          oxford_advanced: {
            amount: '179',
            label: 'OXFORD ADVANCED'
          },
          oxford_all_books: {
            amount: '729',
            label: 'OXFORD ALL BOOKS'
          }
        };
        // Use safe wrapper for fbq; if fbq is undefined or throws, still submit form.
        const safeFbqTrack = (eventName, payload) => {
          try {
            if (typeof fbq === 'function') {
              fbq('track', eventName, payload);
            } else {
              if (window.console && console.warn) console.warn('fbq is not available. Skipping tracking call:', eventName);
            }
          } catch (err) {
            if (window.console && console.error) console.error('Error calling fbq:', err);
          }
        };

        // safeFbqTrack('AddToCart', {
        //   content_ids: membershipString,
        //   content_type: 'product',
        //   content_category: membershipString.includes('premium') ? 'ELSA-PREMIUM' :'ELSA-PRO',
        //   content_name: packageName[membershipString]?.label,
        //   value: packageName[membershipString]?.amount,
        //   currency: 'USD'
        // });
        // safeFbqTrack('CompleteRegistration', {
        //   content_name: packageName[membershipString]?.label,
        //   value: packageName[membershipString]?.amount,
        //   currency: 'USD'
        // });
        // Always submit the form even if fbq is missing or tracking throws.
        form[0].submit();
      }
    });
  });
};

export { formHandler };
